export enum ProjectType {
  PROFESSIONAL,
  PERSONAL,
  COLLEGE,
  SIDE,
  STUDY,
  PROTOTYPE,
  GAMEJAM,
  NONE
}